import { GeneralEnumeration } from "@/types/enumerations";

export const getMappedEnumToSelect = (generalEnum: GeneralEnumeration[]) =>
  generalEnum.map(item => ({
    value: `${item.id}`,
    label: item.name,
  }));
